import React, { Fragment } from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import GenieRow from './GenieRow'
import GenieTableHeader from './GenieTableHeader'
import Error from '../../../common/Error'
import Loader from '../../../common/Loader'
import {
  formatRole,
  formatName,
  formatLeftUntilCap,
  formatPercentageOfCap,
  formatPortfolioSize,
  formatAverageSmartRate
} from './helpers/formatters'
import SmartListingQuery from '../../queries/SmartListingQuery'

const columnWidths = [
  2.5, // Name
  2.5, // Roles
  1,   // Active Loans
  1.3, // Over Cap?
  1.2, // % of Cap
  1.2, // Portfolio Size
  1.2, // SmartRate Average
  1,   // Today
  1,   // Past 4 Days
  1    // Past 30 Days
]

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #bbbbbb;
  border-top-width: 0px;
`
export const ascendingSort = key => {
  return (a, b) => {
    return a.portfolio[key] - b.portfolio[key]
  }
}
export const descendingSort = key => {
  return (a, b) => {
    return b.portfolio[key] - a.portfolio[key]
  }
}
export class GenieTable extends React.Component {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      onClick: PropTypes.func
    })),
    data: PropTypes.shape({
      administrators: PropTypes.arrayOf(PropTypes.object),
      error: PropTypes.any,
      loading: PropTypes.bool
    }),
    order: PropTypes.oneOf(['asc', 'desc']),
    page: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    sortBy: PropTypes.string
  }
  renderHeader = () => {
    const { columns } = this.props
    return <GenieTableHeader columnWidths={columnWidths} columns={columns} />
  }
  renderRows = () => {
    const { data, page, perPage, order = 'desc', sortBy = 'numActiveLoans' } = this.props
    const { administrators } = data
    const sortFn = order === 'asc' ? ascendingSort : descendingSort
    const sortedAdministrators = administrators.slice().sort(sortFn(sortBy))
    const offset = (page - 1) * perPage
    return sortedAdministrators.slice(offset, offset + perPage).map(admin => {
      const adminData = this.getAdminData(admin)
      return (
        <GenieRow
          columnWidths={columnWidths}
          key={admin.rid}
          cells={adminData.length}
          data={adminData}
        />
      )
    })
  }
  getAdminData = admin => {
    const {
      genieSettings,
      portfolio
    } = admin
    const {
      value,
      averageSmartRate,
      percentageOfCap,
      leftUntilCap,
      loansLast30,
      loansLast4,
      loansAssignedToday,
      numActiveLoans
    } = portfolio
    return [
      formatName(admin),
      formatRole(genieSettings),
      numActiveLoans,
      formatLeftUntilCap(leftUntilCap),
      formatPercentageOfCap(percentageOfCap),
      formatPortfolioSize(value),
      formatAverageSmartRate(averageSmartRate),
      loansAssignedToday,
      loansLast4,
      loansLast30
    ]
  }
  render() {
    const { loading, error } = this.props.data

    if (error || loading) {
      return (
        <Fragment>
          {this.renderHeader()}
          {loading ? <Loader number={4} /> : <Error />}
        </Fragment>
      )
    }
    return (
      <Container>
        {this.renderHeader()}
        {this.renderRows()}
      </Container>
    )
  }
}

export default graphql(SmartListingQuery, {
  options: OwnProps => ({
    variables: {
      role: OwnProps.role
    }
  })
})(GenieTable)
